import { DocumentType } from '@nemuru-eng/js-api-client';

import { NIE_DOCUMENT_TYPES } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/constants/nieDocumentTypes';

export const isNieDocumentType = (documentType: DocumentType | undefined | null): boolean =>
  documentType != null && NIE_DOCUMENT_TYPES.includes(documentType);

export const isNieEuDocumentType = (documentType: DocumentType | undefined | null): boolean =>
  documentType === DocumentType.NIE_EU;
